import { render, staticRenderFns } from "./DepartmentRuleDetail.vue?vue&type=template&id=4f192c16"
import script from "./DepartmentRuleDetail.vue?vue&type=script&lang=js"
export * from "./DepartmentRuleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports